import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function ProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Westminster"
      headingExtra="CO"
      introText="Westminster travelers — north Denver metro tech professionals, Front Range Community College students, Adams County families, and Rocky Mountain outdoor enthusiasts — have several passport options. Here is how they compare, and why most Westminster residents choose a registered State Department courier rather than gambling on Denver's single passport agency appointment availability."
      options={options}
      emergencyDescription="Colorado has only 1 passport agency (Denver) serving 5.8M+ statewide residents plus Wyoming's 580K residents who have no agency of their own. Westminster is only ~20 miles from Denver — but I-25 through the Denver metro is one of the most congested corridors in the Mountain West, and rush hour turns 20 miles into 1+ hours of gridlock. Winter blizzards (Oct–April) close I-25 entirely through the Front Range — when the interstate is snow-packed and impassable, Denver's single agency is unreachable. Spring snowstorms routinely strand travelers at Denver International Airport — a Westminster resident discovering an expired passport at DIA cannot reach the Denver agency and make their flight. Mountain pass closures on I-70 divert additional emergency traffic onto Denver routes, further overwhelming the single agency serving the entire Rocky Mountain region."
      disclaimerText="*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing."
    />
  );
}